import _ from 'lodash';
// Method import, not the barrel — bt-frontend/CLAUDE.md. The pre-existing `_`
// barrel above is left alone; converting the whole file is out of this scope.
import get from 'lodash/get';
import { ADD_TO_CART, REMOVE_FROM_CART, UPDATE_CART, CHECK_PROMOTION, CHECK_PROMOTION_ERR, ADD_PROMO_CODE, CREATE_ORDER, CREATE_ORDER_CHAT, UPDATE_PAYMENT, UPDATE_PAYMENT_ERR, PAY_CREDITCARD, CHANGE_QTY, GET_CART, CART_PROCESS, CART_PROCESS_ERR, DELETE_FROM_CART, GET_ORDER_RESPONSE, GET_ORDER_RESPONSE_ERR, GET_PRO_ERR, CLEAR_COUPON_CODE, DISPLAY_FREE_ITEM_POPUP, ADD_TO_BLOGGER_CART, CHANGE_BLOGGER_CART_QTY, DELETE_FROM_BLOGGER_CART, CLEAR_COUPON_ERR_MSG } from './type';
import { SHOW_CART_NOTIFICATION, CLOSE_CART_NOTIFICATiON } from '../common/type';
import { gtm, generateGTMItemValue, pixelAddToCart } from '../../assets/util';

function _addToCart(dispatch, item, qtyToAdd, showNotification = true, addToIndex, review_id = null, categories) {
    if (showNotification) {
        dispatch({
            type: SHOW_CART_NOTIFICATION,
            payload: { item: item, qty: qtyToAdd }
        });
    }
    if (!Array.isArray(item)) {
        gtm('add_to_cart', generateGTMItemValue(item, qtyToAdd, null, categories))
        pixelAddToCart(item, qtyToAdd)
    }
    dispatch({
        type: ADD_TO_CART,
        payload: { item, qty: qtyToAdd, addToIndex: addToIndex, review_id: review_id }
    })
}

export function addToCart(item, qty, showNotification = true, addToIndex, review_id = null) {
    return function (dispatch, getState, { axios }) {
        let qtyToAdd = (typeof qty === "undefined" || qty === null) ? 1 : qty;
        let tempItems = {}
        let addToCartItems = []
        let bloggerCart = []
        if (getState().auth.authenticated) {
            let actionType = 'add';
            let newQty = 0;
            const oldCartItems = getState().cart.items;
            const oldIndex = _.findIndex(oldCartItems, (i) => item.mat_var_id === i.mat_var_id);
            if (oldIndex !== -1) {
                const oldQty = oldCartItems[oldIndex].quantity;
                actionType = 'increase';
                newQty = Math.min(qtyToAdd + oldQty, item.limit);
            }

            if (item.buy_from || item.review_id) {
                dispatch({
                    type: ADD_TO_BLOGGER_CART,
                    payload: { item, qty: qtyToAdd, addToIndex: addToIndex, review_id: review_id }
                })
            }

            if (item.length > 0) {
                _.forEach(item, (i, index) => {
                    if (i.qty) {
                        tempItems[i.mat_var_id] = i.qty
                    } else {
                        if (tempItems[i.mat_var_id]) {
                            tempItems[i.mat_var_id] += 1
                        } else {
                            tempItems[i.mat_var_id] = 1
                        }
                    }
                })
                Object.keys(tempItems).forEach((key) => {
                    let temp = {
                        mat_var_id: +key,
                        quantity: tempItems[key]
                    }
                    addToCartItems.push(temp)
                })
            }

            if (getState().cart.blogger_cart.length > 0) {
                bloggerCart = getState().cart.blogger_cart
            }

            if (item.buy_from && getState().cart.blogger_cart.length <= 0) {
                dispatch(addBloggerCartError())
            }
            axios.post(`/cart`, {
                action: actionType, //increase, decrease, remove, remove all
                mat_var_id: item.mat_var_id,
                quantity: actionType === 'add' ? qtyToAdd : newQty,
                index: addToIndex,
                review_id,
                items: addToCartItems,
                blogger_cart: bloggerCart
            })
                .then((response) => {
                    _addToCart(dispatch, item, qtyToAdd, showNotification, addToIndex, review_id, getState().itemCategories.categories);
                })
                .catch((error) => {

                })
        } else {
            dispatch({
                type: ADD_TO_BLOGGER_CART,
                payload: { item, qty: qtyToAdd, addToIndex: addToIndex, review_id: review_id }
            })
            _addToCart(dispatch, item, qtyToAdd, showNotification, addToIndex, review_id);
        }
    }
}

export function closeCartNotification() {
    return function (dispatch, getState, { axios }) {
        dispatch({
            type: CLOSE_CART_NOTIFICATiON
        })
    }
}

//decrease 1 
export function removeFromCart(index) {
    return function (dispatch, getState, { axios }) {
        const item = getState().cart.items[index]
        gtm('remove_from_cart', generateGTMItemValue(item, 1))
        if (getState().auth.authenticated) {
            //getState().cart get old qty of mat_var_id
            axios.post(`/cart`, {
                action: 'decrease', //increase, decrease, remove, remove all
                mat_var_id: getState().cart.items[index].mat_var_id,
                quantity: getState().cart.items[index].qty - 1,
                // index: addToIndex
            })
                .then((response) => {
                    // _addToCart(dispatch, item, qty, showNotification, addToIndex);
                    dispatch({
                        type: REMOVE_FROM_CART,
                        payload: index
                    })
                })
                .catch((error) => {

                })
        } else {
            dispatch({
                type: REMOVE_FROM_CART,
                payload: index
            })
        }
    }
}

export function deleteFromCart(index) {
    return (dispatch, getState, { axios }) => {
        const item = getState().cart.items[index]
        gtm('remove_from_cart', generateGTMItemValue(item, item.quantity))
        if (getState().auth.authenticated) {
            if (getState().cart.blogger_cart.length > 0) {
                dispatch({
                    type: DELETE_FROM_BLOGGER_CART,
                    payload: index
                })
            }
            axios.post(`/cart`, {
                action: 'remove', //increase, decrease, remove, remove all
                mat_var_id: getState().cart.items[index].mat_var_id,
                blogger_cart: getState().cart.blogger_cart.length > 0 ? getState().cart.blogger_cart : null
            })
                .then((response) => {
                    dispatch({
                        type: DELETE_FROM_CART,
                        payload: index
                    })
                })
                .catch((error) => {

                })
        } else {
            dispatch({
                type: DELETE_FROM_CART,
                payload: index
            })
        }

    }
}

export function changeQty(item, newQty) {
    return (dispatch, getState, { axios }) => {
        let value = newQty;
        if ((newQty === '') || (newQty !== '' && !Number.isInteger(newQty))) {
            value = 1;
        }
        const oldCartItems = getState().cart.items;
        const oldQty = oldCartItems[(_.findIndex(oldCartItems, (i) => item.mat_var_id === i.mat_var_id))].quantity;
        gtm(value > oldQty ? "add_to_cart" : "remove_from_cart", generateGTMItemValue(item, Math.abs(value - oldQty)))

        if (getState().auth.authenticated) {

            if (getState().cart.blogger_cart.length > 0) {
                dispatch({
                    type: CHANGE_BLOGGER_CART_QTY,
                    payload: { item, newQty: value }
                })
            }

            let action = '';
            if (!oldQty || oldQty < value) {
                action = 'increase'
            } else if (oldQty > value) {
                action = 'decrease'
            } else {
                action = 'n/a';
            }

            axios.post(`/cart`, {
                action, //increase, decrease, remove, remove all
                mat_var_id: item.mat_var_id,
                quantity: value,
                blogger_cart: getState().cart.blogger_cart.length > 0 ? getState().cart.blogger_cart : null
            })
                .then((response) => {
                    // _addToCart(dispatch, item, qty, showNotification, addToIndex);
                    dispatch({
                        type: CHANGE_QTY,
                        payload: { item, newQty: value }
                    });
                })
                .catch((error) => {

                })
        }
        else {
            dispatch({
                type: CHANGE_BLOGGER_CART_QTY,
                payload: { item: item, newQty: value }
            })
            dispatch({
                type: CHANGE_QTY,
                payload: { item, newQty: value }
            });
        }

    }
}

export function updateCart(items) {
    return function (dispatch, getState, { axios }) {
        dispatch({
            type: UPDATE_CART,
            payload: items
        });
    }
}

/**
 * Places the order on the WEB charge path, `POST /process_order`.
 *
 * Note this is not the same endpoint the Flutter app uses (`POST /v3/order`)
 * and the two run different `processOrder3` implementations in the backend —
 * root CLAUDE.md rule 2. Money is never computed here: the request carries the
 * cart and the backend answers with the authoritative totals.
 *
 * Converted from a `.then()` chain to async/await under root CLAUDE.md
 * standard 1, because item 01b had to change its rejection handling anyway.
 *
 * @param {Array} items - Cart items; GWP lines are filtered out and quantities expanded.
 * @param {object} address - Delivery address as stored in `state.cart.delivery_address`.
 * @param {Array<string>} promo_code - Promotion codes to apply.
 * @param {string} payment_method - `credit` | `transfer` | ...
 * @param {string|null} [credit_card] - Card token for the credit flow.
 * @param {string|null} event - Campaign event slug, or null.
 * @param {object} additional - `{ point_bt, point_the1, tax_address, the1, referrer, source }`.
 * @returns {Function} redux-thunk dispatching `CREATE_ORDER` with either the
 *          backend response or `{ error: true, message, code, status }`.
 *
 * SIZE: the inner thunk is ~75 lines, at the 80-line limit in root CLAUDE.md
 * standard 3. Item 01b did not add to the payload-assembly bulk — it converted
 * the `.then()` chain and the error branch, which is net-neutral. Splitting the
 * `dataToPost` assembly out is worth doing and is deliberately NOT done here:
 * this is the WEB charge path, it is NAV-bound, and a refactor of it belongs in
 * a change that can carry its own before/after capture.
 */
export function createOrderWithPayment(items, address, promo_code, payment_method, credit_card = null, event, additional) {
    return async function (dispatch, getState, { axios }) {
        dispatch({
            type: CREATE_ORDER,
            payload: null
        });
        const tmp_items = [];
        _.map(_.filter(items, (i) => !i.gwp), (item, index) => {
            _.times(item.quantity < 0 ? 0 : (item.quantity > 99 ? 99 : item.quantity), (n) => {
                tmp_items.push({
                    mat_var_id: item.mat_var_id
                });
            })
        });
        const points = {}
        if (additional.point_bt) {
            points.point_bt = additional.point_bt
        }
        if (additional.point_the1) {
            points.point_the1 = additional.point_the1
        }
        let taxAddress = {};
        if (additional.tax_address) {
            taxAddress = { tax_address: additional.tax_address };
        }
        const dataToPost = {
            items: tmp_items,
            delivery_address: address,

            promo_code: promo_code,
            payment_method: payment_method,
            curr: "THB",
            card_token: credit_card,
            event: event,
            source: 'web',
            blogger_cart: getState().cart.blogger_cart ? getState().cart.blogger_cart : [],
            ...taxAddress,
            ...points
        }
        if (additional.the1) {
            dataToPost.the1 = additional.the1
        }
        if (additional.referrer) {
            dataToPost.referer = additional.referrer
        }
        if (additional.source) {
            dataToPost.sorce = additional.source
        }
        try {
            const response = await axios.post(`/process_order`, dataToPost);
            if (payment_method === "credit" && response.data.authen_url) {
                dispatch({ type: 'LOADING', payload: true });
            }
            dispatch({ type: CREATE_ORDER, payload: response.data });
            // The cart is cleared ONLY here, on the success branch. Every error
            // path below leaves it intact — a customer bounced at checkout must
            // never come back to an empty cart.
            dispatch(clearCart());
        } catch (error) {
            // `code` MUST survive into the payload. The email-verification gate
            // (item 01b) keys on `code === 'EMAIL_NOT_VERIFIED'` to decide
            // whether to render a recoverable "verify and continue" screen or
            // the generic failure dialog. Before this change only `message`
            // reached the reducer, so any error-code-driven UI would silently
            // never render and the customer would get an untranslated Thai
            // fallback with no way forward. Backend contract: the 403 body is
            // `{ message, code }` (`services/signupGuard.js`), and clients
            // branch on `code`, never on the message text.
            const data = get(error, 'response.data', null);
            dispatch({
                type: CREATE_ORDER,
                payload: {
                    error: true,
                    message: get(data, 'message', null) || "มีข้อผิดพลาดเกิดขึ้น โปรดลองใหม่อีกครั้ง",
                    code: get(data, 'code', null),
                    status: get(error, 'response.status', null),
                }
            });
        }
    }
}

export function checkPromotion(promo_code, orders) {
    return function (dispatch, getState, { axios }) {
        //Clear
        dispatch({
            type: CHECK_PROMOTION,
            payload: 0
        });
        dispatch({
            type: CHECK_PROMOTION_ERR,
            payload: ''
        });
        dispatch({
            type: ADD_PROMO_CODE,
            payload: ''
        });

        axios.get(`/promotion`, {
            params: {
                promo_code: promo_code,
                orders: orders
            }
        })
            .then((response) => {
                if (typeof response.data.message !== "undefined" && response.data.message !== '') {
                    dispatch({
                        type: CHECK_PROMOTION_ERR,
                        payload: response.data.message
                    });
                } else {
                    dispatch({
                        type: CHECK_PROMOTION,
                        payload: response.data
                    });
                    dispatch({
                        type: ADD_PROMO_CODE,
                        payload: promo_code
                    });
                }
            })
            .catch((error) => {
                dispatch({
                    type: CHECK_PROMOTION_ERR,
                    payload: error.response || error.message
                });
            });
    }
}

export function updatePayment(so_no, slip, bank, amount, transfer_date) {
    return function (dispatch, getState, { axios }) {
        dispatch({
            type: UPDATE_PAYMENT,
            payload: null
        });
        // dispatch({
        //     type: UPDATE_PAYMENT,
        //     payload: true
        // });
        axios.post(`/update_payment`, {
            so_no: so_no,
            slip: slip,
            bank: bank,
            amount: amount,
            transfer_date: transfer_date
        })
            .then(response => {
                dispatch({
                    type: UPDATE_PAYMENT,
                    payload: true
                });
            })
            .catch(error => {
                dispatch({
                    type: UPDATE_PAYMENT_ERR,
                    payload: error.response?.data || error.message
                });
                dispatch({
                    type: UPDATE_PAYMENT,
                    payload: false
                });

            });
    }
}

export function payByCreditcard(so_no, creditcard_no, savedCard, saveNewCard, card) {
    if (savedCard) {
        return function (dispatch, getState, { axios }) {
            dispatch({
                type: PAY_CREDITCARD,
                payload: null
            });
            axios.post(`/pay_creditcard`, {
                order_id: so_no,
                card_id: creditcard_no,
                saved_card: savedCard,
                saveNewCard: saveNewCard,
            }, {
                headers: {
                    // authorization: localStorage.getItem('token')
                }
            })
                .then((response) => {
                    dispatch({
                        type: PAY_CREDITCARD,
                        payload: true
                    });
                })
                .catch((error) => {
                    dispatch({
                        type: PAY_CREDITCARD,
                        payload: false
                    });
                })
        }
    } else {
        return function (dispatch, getState, { axios }) {
            dispatch({
                type: PAY_CREDITCARD,
                payload: true
            });
        }
    }
}

export function payByCOD(so_no) {
    return function (dispatch, getState, { axios }) {
        dispatch({
            type: UPDATE_PAYMENT,
            payload: null
        });
        axios.post(`/confirm_payment`, {
            so_no: so_no,
            cod: 1
        }, {
            headers: {
                // authorization: localStorage.getItem('token')
            }
        })
            .then((response) => {
                dispatch({
                    type: UPDATE_PAYMENT,
                    payload: true
                });
            })
            .catch((error) => {
                dispatch({
                    type: UPDATE_PAYMENT,
                    payload: false
                });
            })
    }
}

export function saveOrderWithPayment() {
    return (dispatch, getState, { axios }) => {
        dispatch({
            type: CREATE_ORDER,
            payload: null
        });
        dispatch({
            type: CREATE_ORDER,
            payload: true
        });
    }
}

export function processCart(items, additional) {
    return (dispatch, getState, { axios }) => {
        const tmp_items = [];
        _.map(items, (item, index) => {
            const maxQuantity = Math.min(item.quantity, item.limit ? item.limit : item.quantity);
            _.times(item.quantity ? ((item.quantity < 0) ? 0 : Math.min(item.quantity, maxQuantity)) : 1, (n) => {
                tmp_items.push({
                    mat_var_id: item.mat_var_id
                });
            })
        });
        axios.post(`/cart_process`, {
            items: tmp_items,
            curr: "THB",
            source: 'web',
        })
            .then((response) => {
                dispatch({
                    type: CART_PROCESS,
                    payload: response.data
                })
                // dispatch({
                //     type: GET_CART,
                //     payload: {items: response.data.cart}
                // })
            })
            .catch((error) => {
                dispatch({
                    type: CART_PROCESS_ERR
                })
            })
    }
}

export function getOrderResponse(so_no) {
    return (dispatch, getState, { axios }) => {
        dispatch({
            type: GET_ORDER_RESPONSE,
            payload: null
        });
        axios.get(`/order_resp`, {
            params: {
                so_no
            }
        })
            .then((response) => {
                // localStorage.removeItem('temp_token');
                dispatch({
                    type: GET_ORDER_RESPONSE,
                    payload: response.data
                })
            })
            .catch((error) => {
                let err = { code: "ERR.NOT_AVAILABLE" };
                const response = error.response;
                if (response) {
                    const data = response.data;
                    if (data) {
                        err = data.err;
                    }
                }
                dispatch({
                    type: GET_ORDER_RESPONSE_ERR,
                    payload: err
                })
            });
    }
}

export function getCart(merge = false) {
    return (dispatch, getState, { axios }) => {
        if (merge) {
            const localItems = getState().cart.items
            if (localItems.length > 0) {
                axios.post(`/cart`, {
                    action: 'remove all', //increase, decrease, remove, remove all
                })
                    .then((response) => {
                        const tempItems = {}, addToCartItems = []
                        _.forEach(localItems, (i, index) => {
                            if (i.qty) {
                                tempItems[i.mat_var_id] = i.qty
                            } else {
                                if (tempItems[i.mat_var_id]) {
                                    tempItems[i.mat_var_id] += 1
                                } else {
                                    tempItems[i.mat_var_id] = 1
                                }
                            }
                        })
                        Object.keys(tempItems).forEach((key) => {
                            let temp = {
                                mat_var_id: +key,
                                quantity: tempItems[key]
                            }
                            addToCartItems.push(temp)
                        })
                        axios.post(`/cart`, {
                            action: "add",
                            items: addToCartItems,
                        })
                    })
                    .then(() => dispatch(processCart(localItems)))
                    .catch(err => console.log(err))
            } else {
                axios.get(`/cart`)
                    .then((response) => {
                        const { items, blogger_cart } = response.data;
                        dispatch({
                            type: GET_CART,
                            payload: { items, blogger_cart }
                        });

                        dispatch(processCart(items));
                    })
                    .catch((error) => {
                        // console.log (error.response);
                    });
            }
        } else {
            axios.get(`/cart`)
                .then((response) => {
                    const { items, blogger_cart } = response.data;
                    dispatch({
                        type: GET_CART,
                        payload: { items, blogger_cart }
                    });

                    dispatch(processCart(items));
                })
                .catch((error) => {
                    // console.log (error.response);
                });
        }

    }
}

export function clearCart() {
    return (dispatch, getState, { axios }) => {
        if (getState().auth.authenticated) {
            axios.post(`/cart`, {
                action: 'remove all', //increase, decrease, remove, remove all
            })
                .then((response) => {
                    dispatch(getCart());
                })
        } else {
            dispatch(updateCart([]));
        }
    }
}

export function applyDiscountCode(items, code, additional) {
    return (dispatch, getState, { axios }) => {
        const pointBT = additional ? (additional.point_bt || 0) : 0;
        const pointThe1 = additional ? (additional.point_the1 || 0) : 0;
        const tmp_items = [];
        dispatch({
            type: GET_PRO_ERR,
            payload: null
        })
        _.map(items, (item, index) => {
            _.times(item.quantity ? ((item.quantity < 0) ? 0 : item.quantity) : 1, (n) => {
                tmp_items.push({
                    mat_var_id: item.mat_var_id
                });
            })
        });
        axios.post(`/getPro`, {
            items: tmp_items,
            promo_code: code,
            point_bt: pointBT,
            point_the1: pointThe1,
        })
            .then((response) => {
                dispatch({
                    type: CART_PROCESS,
                    payload: response.data
                });
                dispatch({
                    type: GET_PRO_ERR,
                    payload: true
                })
            })
            .catch((error) => {
                console.log(error);
                const data = error.response ? (error.response.data ? error.response.data : false) : false;
                dispatch({
                    type: GET_PRO_ERR,
                    payload: data
                })
            })
    }
}

export function clearCouponCode() {
    return (dispatch, getState, { axios }) => {
        dispatch({
            type: CLEAR_COUPON_CODE,
            payload: null
        })
        dispatch(getCart())
    }
}

export function clearCouponErrorCode() {
    return (dispatch, getState, { axios }) => {
        dispatch({
            type: CLEAR_COUPON_ERR_MSG,
            payload: null
        })
        dispatch(getCart())
    }
}

export function getFreeItems(items) {
    return (dispatch, getState, { axios }) => {
        const tmp_items = [{ mat_var_id: items.mat_var_id }];
        axios.post(`/cart3`, {
            items: tmp_items,
        })
            .then((response) => {
                dispatch({
                    type: CART_PROCESS,
                    payload: response.data
                });
                dispatch({
                    type: DISPLAY_FREE_ITEM_POPUP,
                    payload: { display: true, item: items }
                })
            })
            .catch((error) => {
                // const data = error.response ? (error.response.data? error.response.data : false) : false;
            })
    }
}

export function displayFreeItemsPopup(visible) {
    return (dispatch, getState) => {
        dispatch({
            type: DISPLAY_FREE_ITEM_POPUP,
            payload: { display: visible, item: {} }
        })
    }
}

export function addBloggerCartError() {
    return (dispatch, getState, { axios }) => {
        axios.post(`/cart/blogger/error`)
            .then((response) => {
            })
            .catch((error) => {

            })
    }
}

export function createOrderFromChat(user_id, items, address, promo_code, payment_method, credit_card = null, event, additional) {
    return function (dispatch, getState, { axios }) {
        dispatch({
            type: CREATE_ORDER_CHAT,
            payload: null
        });
        const tmp_items = [];
        _.map(_.filter(items, (i) => !i.gwp), (item, index) => {
            _.times(item.quantity < 0 ? 0 : item.quantity, (n) => {
                tmp_items.push({
                    item_id: item.item_id
                });
            })
        });
        const dataToPost = {
            items: tmp_items,
            delivery_address: address,
            promo_code: promo_code,
            payment_method: payment_method,
            curr: "THB",
            card_token: credit_card,
            event: event,
            blogger_cart: getState().cart.blogger_cart ? getState().cart.blogger_cart : [],
            order_type: "chat",
            user_id: user_id,
        }
        if (additional.the1) {
            dataToPost.the1 = additional.the1
        }
        if (additional.customer_note) {
            dataToPost.customer_note = additional.customer_note;
        }
        if (additional.source) {
            dataToPost.source = additional.source
        }
        axios.post(`/process_order_chat`, dataToPost)
            .then((response) => {
                dispatch({
                    type: CREATE_ORDER_CHAT,
                    payload: response.data
                });
            })
            .catch((error) => {
                let message = "มีข้อผิดพลาดเกิดขึ้น โปรดลองใหม่อีกครั้ง"
                if (error.response) {
                    if (error.response.data) {
                        message = error.response.data.message ? error.response.data.message : "มีข้อผิดพลาดเกิดขึ้น โปรดลองใหม่อีกครั้ง";
                    }
                }
                dispatch({
                    type: CREATE_ORDER_CHAT,
                    payload: { error: true, message: message }
                });
            });
    }
}